/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    ScenarioChooser,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [ScenarioChooser.blockKey]: { render: ScenarioChooser },
};

export default BLOCK_TO_COMPONENT_MAP;
